export class Status {
  constructor(
    public readonly enabled: boolean,
    public readonly activationDate?: string,
    public readonly isDeleted?: boolean,
    public readonly emailConfirmationDate?: string,
  ) {
  }
}
